// promobar scripts
require(['jquery', 'barowlcarousel'], function () {
    jQuery(document).ready(function () {
        var owl = jQuery("#promobar-wrapper");
        owl.on('initialized.owl.carousel', function (e) {
            var owl = jQuery("#promobar-wrapper");
        }).owlCarousel({
            navigation: false,
            responsive: true,
            singleItem: true,
            pagination: false,
            autoPlay: false,
            transitionStyle: "fade",
            stopOnHover: true,
            autoHeight: true,
            mouseDrag: false,
            touchDrag: false
        });

        jQuery('.promobar.pb').on('mouseover', function () {
            jQuery(".pb-attribution").stop().addClass('visible');
            jQuery(".pb-close-button").stop().addClass('visible');
        }).on('mouseout', function () {
            jQuery(".pb-attribution").stop().removeClass('visible');
            jQuery(".pb-close-button").stop().removeClass('visible');
        });

        jQuery('.pb-close-bar,.pb-close-button').click(function () {
            jQuery('#promobar-wrapper').slideUp("slow");
        });
    });
});

// review form show/hide
require(['jquery'], function ($) {
    $(".catalog-product-view .block.review-add").hide();
    jQuery('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        var target = this.hash;
        if (target == "#review-form") {
            jQuery(".catalog-product-view .block.review-add").show();
            $('html, body').animate({
                scrollTop: $("#review-form").offset().top
            }, 200);
        }
    });
    $(".reviews-actions a.action").click(function () {
        jQuery(".catalog-product-view .block.review-add").show();
        $('html, body').animate({
            scrollTop: $("#review-form").offset().top
        }, 200);
    });
});

// bundle option select for shop page.
require(['jquery'], function ($) {
    $('.bundle-option_select').on('change', function () {
        var selectionId = $('option:selected', this).attr(
            'data-selection-id');
        var optionId = this.value;
        var productId = $(this).attr('data-product-id');
        $('#bundle_option_id_' + productId).val(selectionId);
        $('#bundle_option_id_' + productId).attr('name', 'bundle_option[' +
            optionId + ']');
        $('#bundle_option_qty_' + productId).attr('name',
            'bundle_option_qty[' + optionId + ']');
    })
});

// instagram posts data script

$(document).ready(function () {
    var accessToken = '';
    $('.post-content').remove();
    $.ajax({
        url: 'https://api.instagram.com/v1/users/self/media/recent?count=6&access_token=' + accessToken,
        dataType: 'jsonp',
        success: function (response) {
            if (response.meta.code == 200) {
                const data = response.data;

                for (let i = 0; i < 2; i++) {
                    const media = data[i];

                    var date = new Date( media.caption.created_time *1000);
                    var options = { year: 'numeric', month: 'long', day: 'numeric' };
                    date = date.toLocaleString('en-US', options);
                    var caption = media.caption.text;

                    $('.latest-posts').append(`
                        <div class="post-content">
                            <p>"` + caption.substring(0, 50) + `..." </p>
                            <span>` + date + ` / Instagram</span>
                        </div>
                    `);
                }
            } else {
                console.log('Instagram API response', response)
            }
        }
    })
});


//************ cart scripts ****************

// cart function calls
$(document).ready(function () {
  
    // Cart Drawer show/hide
    $('a.showcart, #btn-minicart-close').on('click', function (e) {
        e.preventDefault();
        openCartDrawer();
    });

    // product page scripts

    //quantity selector
    $('.option-control').on('click', function(e){
      e.preventDefault();
      var minVal = 0,
        maxVal = 1000,
        input = $(this).siblings('.option-quantity'),
        dataType = $(this).attr('data-type'),
        currentVal = parseInt(input.val()),
        totalVal = 0,
        totalItems = 0,
        newVal = 0,
        imgSrc = input.data('img-src');

      $('.product-option').each(function(){
        var newVal = parseFloat($(this).find('.option-quantity').val());
        if(newVal){totalVal = parseFloat(totalVal + newVal);}
      });
      if(totalVal < maxVal){
        if(dataType == 'plus') {
          if(currentVal < maxVal){
            input.val(currentVal + 1).change();
            totalItems += 1;
            updatePriceATC((currentVal + 1), $(this));
          }
        }
      }
      if(dataType == 'minus') {
        if(currentVal > minVal){
          input.val(currentVal - 1).change();
          totalItems -= 1;
          updatePriceATC((currentVal - 1), $(this));
        }
      }
      
    });

});

// cart update products on quantity change.
$(document)
    .on("change", ".option-quantity ", function () {
        var currentVal = parseInt($(this).val());
        if(isNaN(currentVal)) {
            var currentVal = 0;
        }
        updatePriceATC(currentVal, $(this));
    })
    .trigger("change");


// cart update products on quantity change.
$(document)
    .on("change", ".item-qty", function () {
        var $item = $(this).closest(".product-item");
        var $cart = $("#minicart-content-wrapper");
        var line = parseInt($item.data("line"));
        var quantity = parseInt($(this).val());
        updateCartQuantity($cart, $item, line, quantity);
    })
    .trigger("change");

// update product quantity function
function updateCartQuantity($cart, $item, line, quantity) {
    jQuery.post(
        "/cart/change.js", {
            line: line,
            quantity: quantity,
        },
        function (data) {
            if (data.status && data.status == 422) {
                return;
            }

            if (data.item_count == 0) {
                // change cart state to empty
                updateCartState("empty");
            } else {
                updateCartState();

                if (quantity == 0) {
                    $item.fadeOut(250, function () {
                        $item.remove();

                        $cart.find(".product-item").each(function (index, elem) {
                            $(elem).attr("data-line", index + 1);
                        });
                    });
                }

                // update cart totals
                $cart
                    .find(".items-total .count")
                    .text(data.item_count == 1 ? "" + data.item_count + " Item" : "" + data.item_count + " Items");
                $cart.find(".subtotal span.price").text(Shopify.formatMoney(data.total_price));
                updateCartCounter(data.item_count)
            }
        },
        "json"
    );
}

// update cart state after change
function updateCartState(state) {
    var $cart = $("#minicart-content-wrapper");
    if (state == "empty") {
        if (!$cart.hasClass("cart-is-empty")) {
            $cart.find(".cart-form").fadeOut(100, function () {
                $cart.find(".empty-cart").fadeIn(100);
            });
        }

        $cart.addClass("cart-is-empty");
        $cart.find(".products-list").empty();
        updateCartCounter(0);
    } else {
        if ($cart.hasClass("cart-is-empty")) {
            $cart.find(".empty-cart").fadeOut(100, function () {
                $cart.find(".cart-form").fadeIn(100);
            });
        }
        $cart.removeClass("cart-is-empty");
    }
}

// show cart popup
function openCartDrawer() {
    $('div.block-minicart').toggle(150);
}

// load cart items data
function fetchCartData() {
    var cartData = false;

    $.ajax({
        dataType: "jsonp",
        url: "/cart.json?callback=?",
        success: function (data) {
            cartData = data;
        },
    });

    return cartData;
}

// change counter on main menu in header
function updateCartCounter(itemCount) {
    var $cartWrap = $('.minicart-wrapper');
    var label = 'Shopping cart, ' + itemCount + ' ' + ((itemCount == 1) ? 'item' : 'items');

    $cartWrap.find('.showcart').attr('title', label).attr('aria-label', label);
    $cartWrap.find('.counter-number').text(itemCount);
}


// change product price in add to cart button
function updatePriceATC(item_count, $this){
    var $priceSpan =  $this.parents('.actions').find('span.btn-prod-price'),
    priceVal = $priceSpan.data('price'),
    shopCurrency = $priceSpan.data('currency'),
    updatedPriceVal = 0;

    updatedPriceVal = (priceVal * item_count)/100;
    $priceSpan.text(shopCurrency + parseFloat(updatedPriceVal).toFixed(2));
}
      
 
 

  